<template>
  <div class="contact">
    <div class="section-background">
      <div class="container">
        <div class="hero">
          <div class="text">
            <p class="sub-title">
              Get in touch with us
            </p>
            <h1 class="title">
              Contact
            </h1>
          </div>
          <div class="row">
            <div class="col-12 col-md-4 contact-block">
              <i class="material-icons">mail_outline</i>
              <p>
                Question or suggestions?
                <br>Drop us a line
              </p>
              <a href="mailto:hello@ludimos.com">hello@ludimos.com</a>
            </div>
            <div class="col-12 col-md-4 contact-block">
              <i class="material-icons">my_location</i>
              <p>
                In De wolken 226
                <br>1186 BP Amstelveen <br>The Netherlands
              </p>
            </div>
            <div class="col-12 col-md-4 contact-block">
              <i class="material-icons">local_phone</i>
              <p>
                Call us
                <br>Mon - Fri: 09:00 - 17:00 CET
              </p>
              <a href="tel:+31652779113">+31652779113</a>
            </div>
          </div>
          <div class="contact-map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2440.4633101998293!2d4.869537015798878!3d52.28944477977123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c60a911a7021f5%3A0x6e2082daf2411ae!2sIn%20de%20Wolken%20226%2C%201186%20BP%20Amstelveen!5e0!3m2!1snl!2snl!4v1583406140258!5m2!1snl!2snl"
              width="100%"
              height="500"
              frameborder="0"
              style="border:0;"
              allowfullscreen
            />
          </div>

          <div class="visual">
            <div class="background">
              <img
                src="../assets/img/hero-background.svg"
                alt="background visual"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Contact",
  mounted() {
    // Tracking code
    this.$ma.trackEvent({
      fb_event: "Lead",
      category: "Menu",
      action: "Menu",
      label: "Contact",
      type: "Contact",
    });
  },
  metaInfo() {
    return {
      title: 'Ludimos - Get In Touch With us',
    };
  },
};
</script>
<style scoped lang="scss">
.contact-block {
  text-align: center;
  position: relative;
  z-index: 1;

  p {
    margin: 0;
  }
  i {
    font-size: 50px;
    color: #fff;
    margin: 30px 0;
    background: #6f44ff;
    padding: 20px;
    border-radius: 5px;
  }
  a {
    display: block;
  }
}
.contact-map {
  position: relative;
  z-index: 1;
  margin: 50px 0;
  iframe {
    background: #fff;
    padding: 5px;
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
  }
}
</style>
